<script>
import posthog from 'posthog-js'
import Swal from 'sweetalert2'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import tokenize from '~/plugins/tokenize';
import { init3dsData, wait3dsResponse } from '~/plugins/cielo3ds.js'

export default {
    name: 'Payment',
    props: ['submitting', 'payment_method'],
    setup() {
        // const url_base_obrigado = 'https://payvue.varejistaonline.com/customer';
        // return {
        //     url_base_obrigado
        // }
    },
    methods: {
        async getCardHash() {
            console.warn('INIT PAYMENT GATEWAY')

            var card_expiration = this.$store.getters[
                'getPaymentData'
            ].card_expiration.replace(/\s/g, '')
            var card_expirationYearShort =
                card_expiration.split('/')[1].length === 4 ?
                    card_expiration
                        .split('/')[1]
                        .substr(card_expiration.split('/')[1].length - 2) :
                    card_expiration.split('/')[1]
            var card_expirationLong =
                card_expiration.split('/')[1].length === 4 ?
                    card_expiration.split('/')[1] :
                    `20${card_expiration.split('/')[1]}`

            var card_expiration = `${card_expiration.split('/')[0]
                }/${card_expirationYearShort}`

            this.$store.commit('setPaymentData', {
                card_number: this.$store.getters[
                    'getPaymentData'
                ].card_number.replace(/^(\+)|\D/g, ''),
                card_holdername: this.$store.getters['getPaymentData'].card_holdername,
                card_expiration: card_expiration,
                card_expiration_full: `${card_expiration.split('/')[0]
                    }/${card_expirationLong}`,
                card_cvv: this.$store.getters[
                    'getPaymentData'
                ].card_cvv.replace(/^(\+)|\D/g, ''),
            })

            if (typeof this.$store.getters['getGateway'].gateway_whitelabel_name !== 'undefined' && this.$store.getters['getGateway'].gateway_whitelabel_name != null && this.$store.getters['getGateway'].gateway_whitelabel_name === 'shield') {
                ShieldTech.setPublicKey(this.$store.getters['getGateway'].gateway_public_key);

                var card_expiration = this.$store.getters['getPaymentData'].card_expiration.replace(/\s/g, '')
                var card_expirationYearShort = card_expiration.split('/')[1].length === 4 ? card_expiration.split('/')[1].substr(card_expiration.split('/')[1].length - 2) : card_expiration.split('/')[1]
                var card_expirationLong = card_expiration.split('/')[1].length === 4 ? card_expiration.split('/')[1] : `20${card_expiration.split('/')[1]}`

                var card_expiration = `${card_expiration.split('/')[0]}/${card_expirationYearShort}`

                var token = await ShieldTech.encrypt({
                    number: this.$store.getters['getPaymentData'].card_number.replace(/^(\+)|\D/g, ''),
                    holderName: this.$store.getters['getPaymentData'].card_holdername,
                    expMonth: card_expiration.split('/')[0],
                    expYear: card_expirationLong,
                    cvv: this.$store.getters['getPaymentData'].card_cvv.replace(/^(\+)|\D/g, '')
                });

                return this.RequestPayment('credit-card', token)
            } else if (this.$store.getters['getGateway'].gateway_platform === 'hunterPay') {
                return this.RequestPayment('credit-card')
            } else if (this.$store.getters['getGateway'].gateway_platform === 'mercadopago') {
                const mp = new MercadoPago(
                    this.$store.getters['getGateway'].gateway_public_key
                )

                const cardToken = await mp.createCardToken({
                    cardNumber: this.$store.getters[
                        'getPaymentData'
                    ].card_number.replace(/^(\+)|\D/g, ''),
                    cardholderName: this.$store.getters['getPaymentData'].card_holdername,
                    cardExpirationMonth: card_expiration.split('/')[0],
                    cardExpirationYear: card_expiration.split('/')[1],
                    securityCode: this.$store.getters[
                        'getPaymentData'
                    ].card_cvv.replace(/^(\+)|\D/g, ''),
                    identificationType: 'CPF',
                    identificationNumber: this.$store.getters[
                        'getCustomer'
                    ].document.replace(/^(\+)|\D/g, ''),
                })

                const paymentMethods = await mp.getPaymentMethods({
                    bin: this.$store.getters['getPaymentData'].card_number
                        .replace(/^(\+)|\D/g, '')
                        .slice(0, 8),
                })

                return this.RequestPayment('credit-card', cardToken, paymentMethods)
            } else if (this.$store.getters['getGateway'].gateway_platform === 'pagarmev2') {
                return this.RequestPayment('credit-card', '', '')
            } else if (this.$store.getters['getGateway'].gateway_platform === this.$store.state.company_name && (this.$store.getters['getGateway'].acquirer_name === this.$store.state.company_name || this.$store.getters['getGateway'].acquirer_name == 'iugu')) {
                if (typeof this.$store.getters['getGateway'].recipient !== 'undefined' && this.$store.getters['getGateway'].recipient?.gateway === 'mercadopago') {

                    const mp = new MercadoPago(
                        this.$store.getters['getGateway'].gateway_public_key
                    )

                    const cardToken = await mp.createCardToken({
                        cardNumber: this.$store.getters[
                            'getPaymentData'
                        ].card_number.replace(/^(\+)|\D/g, ''),
                        cardholderName: this.$store.getters['getPaymentData']
                            .card_holdername,
                        cardExpirationMonth: card_expiration.split('/')[0],
                        cardExpirationYear: card_expiration.split('/')[1],
                        securityCode: this.$store.getters[
                            'getPaymentData'
                        ].card_cvv.replace(/^(\+)|\D/g, ''),
                        identificationType: 'CPF',
                        identificationNumber: this.$store.getters[
                            'getCustomer'
                        ].document.replace(/^(\+)|\D/g, ''),
                    })

                    const paymentMethods = await mp.getPaymentMethods({
                        bin: this.$store.getters['getPaymentData'].card_number
                            .replace(/^(\+)|\D/g, '')
                            .slice(0, 8),
                    })

                    return this.RequestPayment(
                        'credit-card',
                        cardToken.id ?? null,
                        paymentMethods.results[0] ?? null
                    )
                } else if (typeof this.$store.getters['getGateway'].acquirer_name !== 'undefined' && this.$store.getters['getGateway'].acquirer_name === 'dompagamentos' && this.$store.getters['getGateway'].gateway_platform !== 'onnecart') {
                    try {
                        var card_expiration = this.$store.getters[
                            'getPaymentData'
                        ].card_expiration.replace(/\s/g, '')
                        var card_expirationYearShort =
                            card_expiration.split('/')[1].length === 4 ?
                                card_expiration
                                    .split('/')[1]
                                    .substr(
                                        card_expiration.split('/')[1].length - 2
                                    ) :
                                card_expiration.split('/')[1]
                        var card_expirationLong =
                            card_expiration.split('/')[1].length === 4 ?
                                card_expiration.split('/')[1] :
                                `20${card_expiration.split('/')[1]}`

                        var card_expiration = `${card_expiration.split('/')[0]
                            }/${card_expirationYearShort}`

                        const card_data = {
                            number: this.$store.getters[
                                'getPaymentData'
                            ].card_number.replace(/^(\+)|\D/g, ''),
                            document: this.$store.getters[
                                'getCustomer'
                            ].document.replace(/^(\+)|\D/g, ''),
                            name: this.$store.getters['getPaymentData']
                                .card_holdername,
                            month: card_expiration.split('/')[0],
                            year: card_expirationLong,
                            cvv: this.$store.getters[
                                'getPaymentData'
                            ].card_cvv.replace(/^(\+)|\D/g, ''),
                        };

                        var cardToken = await getTokenCard(this.$store.getters['getGateway'].gateway_public_key, card_data, this.$store.getters['getInstallments'], function (data) {
                            if (data.token) {
                                return data;
                            }
                        });

                        return this.RequestPayment('credit-card', cardToken)
                    } catch (err) {
                        console.error(err)
                    }
                } else if (typeof this.$store.getters['getGateway'].acquirer_name !== 'undefined' && this.$store.getters['getGateway'].acquirer_name === 'iugu') {
                    try {
                        const formatCreditCardExpiry = (expiry) => {
                            expiry = expiry.replace(/\s/g, "");
                            console.warn(expiry)
                            // Verifica se o formato está correto (MM/YY)
                            if (/^\d{2}\/\d{4}$/.test(expiry)) {
                                return expiry;
                            }

                            // Divide a string pelo caractere "/"
                            const [month, year] = expiry.split('/');

                            // Adiciona "20" na frente do ano para transformar "YY" em "YYYY"
                            const fullYear = '20' + year;

                            // Retorna o novo formato "MM/YYYY"
                            return `${month}/${fullYear}`;
                        }

                        var card_expiration = this.$store.getters['getPaymentData'].card_expiration.replace(/\s/g, '')
                        var card_expiration = formatCreditCardExpiry(card_expiration);

                        console.warn(card_expiration)
                        Iugu.setAccountID(this.$store.getters['getGateway'].gateway_public_key);

                        Iugu.setup();




                        let cc = Iugu.CreditCard(this.$store.getters[
                            'getPaymentData'
                        ].card_number.replace(/^(\+)|\D/g, ''),
                            card_expiration.split('/')[0],
                            card_expiration.split('/')[1],
                            this.$store.getters[
                                'getCustomer'
                            ].name.split(" ")[0],
                            this.$store.getters[
                                'getCustomer'
                            ].name.split(" ")[1],
                            this.$store.getters[
                                'getPaymentData'
                            ].card_cvv.replace(/^(\+)|\D/g, ''))

                        const token = await new Promise((resolve, reject) => {
                            Iugu.createPaymentToken(cc, function (response) {
                                if (response.errors) {
                                    reject({ message: 'Erro ao tokenizar o cartão', error: response });
                                } else {
                                    console.warn("Cartão tokenizado com sucesso!", response.id);

                                    resolve(response.id);
                                }
                            });
                        });

                        console.warn("O TOKEN", token);

                        return this.RequestPayment('credit-card', token)



                    } catch (err) {
                        console.error(err)
                    }
                } else {
                    const internal_card_token = tokenize(this.$store.getters['getPaymentData'], this.$store.getters['getStore'].public_key)
                    return this.RequestPayment('credit-card', internal_card_token)
                }
            } else if (
                this.$store.getters['getGateway'].gateway_platform === 'appmax'
            ) {
                return this.RequestPayment('credit-card')
            } else if (this.$store.getters['getGateway'].gateway_platform === 'abmex') {
                try {
                    var card_expiration = this.$store.getters[
                        'getPaymentData'
                    ].card_expiration.replace(/\s/g, '')
                    var card_expirationYearShort =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration
                                .split('/')[1]
                                .substr(
                                    card_expiration.split('/')[1].length - 2
                                ) :
                            card_expiration.split('/')[1]
                    var card_expirationLong =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration.split('/')[1] :
                            `20${card_expiration.split('/')[1]}`

                    var card_expiration = `${card_expiration.split('/')[0]
                        }/${card_expirationYearShort}`

                    AbmexPay.setPublicKey(
                        this.$store.getters['getGateway'].gateway_public_key
                    )
                    // AbmexPay.setTestMode(false)
                    AbmexPay.setTestMode(
                        process.env.NODE_ENV === 'production' ? false : true
                    )

                    var cardToken = await AbmexPay.encrypt({
                        number: this.$store.getters[
                            'getPaymentData'
                        ].card_number.replace(/^(\+)|\D/g, ''),
                        holderName: this.$store.getters['getPaymentData']
                            .card_holdername,
                        expMonth: card_expiration.split('/')[0],
                        expYear: card_expirationLong,
                        cvv: this.$store.getters[
                            'getPaymentData'
                        ].card_cvv.replace(/^(\+)|\D/g, ''),
                    })

                    return this.RequestPayment('credit-card', cardToken)
                } catch (err) {
                    fetch(
                        `https://api.${this.$store.getters['getDomain']}/api/api/notifications/errors`, {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            title: `[ÚnicoPag] AbmexPay getcardToken - Error`,
                            message: `${err} - ${window.AbmexPay}`,
                            sound: 'mechanical',
                        }),
                    }
                    )
                }
            } else if (
                this.$store.getters['getGateway'].gateway_platform ===
                'paybeehive'
            ) {

                try {
                    var card_expiration = this.$store.getters[
                        'getPaymentData'
                    ].card_expiration.replace(/\s/g, '')
                    var card_expirationYearShort =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration
                                .split('/')[1]
                                .substr(
                                    card_expiration.split('/')[1].length - 2
                                ) :
                            card_expiration.split('/')[1]
                    var card_expirationLong =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration.split('/')[1] :
                            `20${card_expiration.split('/')[1]}`

                    var card_expiration = `${card_expiration.split('/')[0]
                        }/${card_expirationYearShort}`

                    if (process.env.NODE_ENV === 'production') {
                        BeehivePay.setPublicKey(
                            this.$store.getters['getGateway'].gateway_public_key
                        )
                        // AbmexPay.setTestMode(false)
                        BeehivePay.setTestMode(
                            process.env.NODE_ENV === 'production' ? false : true
                        )

                        var cardToken = await BeehivePay.encrypt({
                            number: this.$store.getters[
                                'getPaymentData'
                            ].card_number.replace(/^(\+)|\D/g, ''),
                            holderName: this.$store.getters['getPaymentData']
                                .card_holdername,
                            expMonth: card_expiration.split('/')[0],
                            expYear: card_expirationLong,
                            cvv: this.$store.getters[
                                'getPaymentData'
                            ].card_cvv.replace(/^(\+)|\D/g, ''),
                        })
                    }

                    return this.RequestPayment('credit-card', cardToken)
                } catch (err) {
                    console.error(err)
                }
            } else if (
                (this.$store.getters['getGateway'].gateway_platform === 'dompagamentos' || (this.$store.getters['getGateway'].acquirer_name === 'dompagamentos' || typeof this.$store.getters['getGateway'].acquirer_name === 'undefined')) ||
                (this.$store.getters['getGateway'].acquirer_name === 'unicopag' && this.$store.getters['getGateway'].gateway_platform == 'onnecart') ||
                (this.$store.getters['getGateway'].acquirer_name === 'barte' && this.$store.getters['getGateway'].gateway_platform == 'unicopag')
            ) {
                try {
                    var card_expiration = this.$store.getters[
                        'getPaymentData'
                    ].card_expiration.replace(/\s/g, '')
                    var card_expirationYearShort =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration
                                .split('/')[1]
                                .substr(
                                    card_expiration.split('/')[1].length - 2
                                ) :
                            card_expiration.split('/')[1]
                    var card_expirationLong =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration.split('/')[1] :
                            `20${card_expiration.split('/')[1]}`

                    var card_expiration = `${card_expiration.split('/')[0]
                        }/${card_expirationYearShort}`

                    const card_data = {
                        number: this.$store.getters[
                            'getPaymentData'
                        ].card_number.replace(/^(\+)|\D/g, ''),
                        document: this.$store.getters[
                            'getCustomer'
                        ].document.replace(/^(\+)|\D/g, ''),
                        name: this.$store.getters['getPaymentData']
                            .card_holdername,
                        month: card_expiration.split('/')[0],
                        year: card_expirationLong,
                        cvv: this.$store.getters[
                            'getPaymentData'
                        ].card_cvv.replace(/^(\+)|\D/g, ''),
                    };

                    var cardToken = await getTokenCard(this.$store.getters['getGateway'].gateway_public_key, card_data, this.$store.getters['getInstallments'], function (data) {
                        if (data.token) {
                            return data;
                        }
                    });

                    return this.RequestPayment('credit-card', cardToken)
                } catch (err) {
                    console.error(err)
                }
            } else if (
                this.$store.getters['getGateway'].gateway_platform ===
                'paglemon'
            ) {
                this.RequestPayment('credit-card')
            } else if (this.$store.getters['getGateway'].gateway_platform === 'dompagamentos') {
                try {
                    var card_expiration = this.$store.getters[
                        'getPaymentData'
                    ].card_expiration.replace(/\s/g, '')
                    var card_expirationYearShort =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration
                                .split('/')[1]
                                .substr(
                                    card_expiration.split('/')[1].length - 2
                                ) :
                            card_expiration.split('/')[1]
                    var card_expirationLong =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration.split('/')[1] :
                            `20${card_expiration.split('/')[1]}`

                    var card_expiration = `${card_expiration.split('/')[0]
                        }/${card_expirationYearShort}`

                    const card_data = {
                        number: this.$store.getters[
                            'getPaymentData'
                        ].card_number.replace(/^(\+)|\D/g, ''),
                        document: this.$store.getters[
                            'getCustomer'
                        ].document.replace(/^(\+)|\D/g, ''),
                        name: this.$store.getters['getPaymentData']
                            .card_holdername,
                        month: card_expiration.split('/')[0],
                        year: card_expirationLong,
                        cvv: this.$store.getters[
                            'getPaymentData'
                        ].card_cvv.replace(/^(\+)|\D/g, ''),
                    };

                    var cardToken = await getTokenCard(this.$store.getters['getGateway'].gateway_public_key, card_data, this.$store.getters['getInstallments'], function (data) {
                        if (data.token) {
                            return data;
                        }
                    });

                    this.RequestPayment('credit-card', cardToken)
                } catch (err) {
                    console.error(err)
                }
            }
            
            try {
                if (this.$store.getters['getGateway']?.credit_card_3ds) {
                    console.warn('initCielo');

                    var card_expirationLong =
                        card_expiration.split('/')[1].length === 4 ?
                            card_expiration.split('/')[1] :
                            `20${card_expiration.split('/')[1]}`

                    await init3dsData({
                        accessToken: this.$store.getters['getGateway'].gateway_public_key,
                        orderNumber: `ORD-${Date.now()}`,
                        amount: this.$store.getters['getSumary'].total_amount,
                        paymentMethod: 'credit',
                        currency: '986',
                        cardNumber: this.$store.getters['getPaymentData'].card_number.replace(/^(\+)|\D/g, ''),
                        expMonth: card_expiration.split('/')[0],
                        expYear: card_expirationLong,
                        card_holdername: this.$store.getters['getPaymentData'].card_holdername,
                        customer: this.$store.getters['getCustomer'],
                        installments: this.$store.getters['getSumary'].installments
                    });

                    const script = document.createElement('script');
                    script.src = 'https://mpi.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js';
                    // script.src = 'https://mpisandbox.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js';
                    script.view = 'checkout';

                    script.onload = () => {
                        console.log('Script Braspag 3DS carregado!');
                        const button = document.createElement('input');
                        button.type = 'button';
                        button.id = 'btnSendOrder';
                        button.onclick = () => this.sendOrder();
                        document.body.appendChild(button);
                    };

                    document.head.appendChild(script);

                    // Aguarda a execução do onReady
                    const waitForOnReady = new Promise((resolve) => {
                        window._on3dsReady = resolve;
                    });
                
                    await waitForOnReady;
                    

                    // Ativa o botão que dispara o fluxo 3DS
                    document.getElementById("btnSendOrder")?.click();

                    // Aguarda o resultado do 3DS se vai aparecer o modal ou não!
                    const cardToken = await wait3dsResponse();

                    // Adiciona o número do pedido "orderNumber"
                    const bpmpi_ordernumber = document.getElementsByClassName('bpmpi_ordernumber');
                    cardToken.bpmpi_ordernumber = bpmpi_ordernumber[0]?.value;

                    if (cardToken.status == 'unsupportedBrand' || cardToken.status == 'error' || cardToken.status == 'failure') {
                        Swal.fire({
                            title: 'Erro ao Realizar o Pagamento',
                            icon: 'error',
                            showCancelButton: false,
                            cancelButtonColor: '#6c757d',
                            cancelButtonText: 'Fechar',
                            returnFocus: false,
                        });
                        return false;
                    }

                    return this.RequestPayment('credit-card', cardToken);
                } 
            } catch (error) {
                console.error('Erro ao gerar o token do cartão via 3DS', error)
            }
            
            return this.RequestPayment('credit-card')
        },
        actPix() {
            Swal.fire({
                title: 'Processando seu pagamento',
                html: 'Aguarde um momento...',
                allowOutsideClick: !1,
                returnFocus: false,
                showCancelButton: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            return this.RequestPayment('payment-pix', null, null)
            this.$store.dispatch('callEventTracker', {
                event: 'Purchase',
                extra_params: {
                    payment_method: 'pix',
                    email: this.$store.getters['getCustomer'].email,
                },
            })
            posthog.capture('actPix')
        },
        actBillet() {
            Swal.fire({
                title: 'Processando seu pagamento',
                html: 'Aguarde um momento...',
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: !1,
                returnFocus: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            return this.RequestPayment('payment-billet', null, null)

            this.$store.dispatch('callEventTracker', {
                event: 'Purchase',
                extra_params: {
                    payment_method: 'billet',
                    email: this.$store.getters['getCustomer'].email,
                },
            })
            posthog.capture('actBillet')
        },
        actCreditcard() {
            Swal.fire({
                title: 'Processando seu pagamento',
                html: 'Aguarde um momento...',
                allowOutsideClick: !1,
                showCancelButton: false,
                showConfirmButton: false,
                returnFocus: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            this.getCardHash()

            this.$store.dispatch('callEventTracker', {
                event: 'Purchase',
                extra_params: {
                    payment_method: 'credit_card',
                    email: this.$store.getters['getCustomer'].email,
                },
            })
        },
        async callRetry(result) {
            let this_el = this

            return new Promise(function (resolve, reject) {
                if (typeof result.retry !== 'undefined' && this_el.count_retrys < 1) {
                    let nextGateway = this_el.$store.state.gateways_retry.find(
                        (u) =>
                            u.retry_enable === 1 &&
                            u.gateway_id !==
                            this_el.$store.getters['getGateway'].gateway_id
                    )

                    if (nextGateway) {
                        this_el.count_retrys++

                        this_el.$store.commit('setGatewayToRetry', nextGateway)

                        this_el.$nextTick(() => {
                            this_el.last_transaction_hash_retry = result.hash
                            this_el.actCreditcard()
                            resolve(true)
                        })
                    } else {
                        resolve(false)
                    }
                } else {
                    resolve(false)
                }
            })
        },
        async RequestPayment(action, card_hash = null, paymentMethods = null) {
            let this_el = this

            if(this.$store.getters['getDeviceId'] === null){
                this.$store.commit('setDeviceId', window.MP_DEVICE_SESSION_ID);                
            }

            let body = {
                customer_hash: this.$store.getters['getCustomer'].hash,
                coupon: {
                    id: this.$store.getters['getCoupon'].id ?? null,
                },
                card: {
                    attempt_reference: localStorage.getItem('attempt_reference') ?? null,
                    card_number: this.$store.getters[
                        'getPaymentData'
                    ].card_number.replace(/^(\+)|\D/g, ''),
                    cvv: this.$store.getters['getPaymentData'].card_cvv.replace(
                        /^(\+)|\D/g,
                        ''
                    ),
                    token: tokenize(this.$store.getters['getPaymentData'], this.$store.getters['getStore'].public_key),
                },
                gateway: this.$store.getters['getGateway'],
                cart: this.$store.getters['getCart'],
                customer: this.$store.getters['getCustomer'],
                payment_method: this.$store.getters['getPaymentMethodSelected'],
                installments: this.$store.getters['getPaymentMethodSelected'] == 1 ?
                    this.$store.getters['getInstallments'] :
                    1,
                card_hash: card_hash,
                mercadopago: paymentMethods,
                paymentData: this.$store.getters['getPaymentData'],
                tracking: this.$store.getters['getTracking'],
                shipping: this.$store.getters['getShipping'],
                last_transaction_hash_retry: this.last_transaction_hash_retry,
                custom_form_options: this.$store.getters['getCustomFormOptions'],
                device_id: this.$store.getters['getDeviceId']
            }

            console.warn("TENTANDO FAZER O REQUEST DO PAGAMENTO COM ESSES DADOS", body)

            try {
                let enviromentURL =
                    process.env.NODE_ENV === 'production' ?
                        `https://api.${this.$store.getters['getDomain']}/api/api` :
                        process.env.BASE_URL_API

                if (process.env.NODE_ENV == 'production' && this.$store.getters['getCompanyName'] == 'unicopag') {
                    enviromentURL = this.$config.URL_API;
                }

                const responseData = await this.$axios.post(
                    `${enviromentURL}/requestPayment`,
                    body
                )
                const result = await responseData.data

                const retryGateway = await this.callRetry(result)

                if (retryGateway === false) {
                    if (typeof result.errors !== 'undefined') {
                        console.error(result)
                        posthog.capture('paymentError', {
                            msg: result.errors
                        })

                        Swal.fire({
                            title: 'Erro ao Realizar o Pagamento',
                            html: result.errors,
                            icon: 'error',
                            showCancelButton: false,
                            cancelButtonColor: '#6c757d',
                            cancelButtonText: 'Fechar',
                            returnFocus: false,
                        })

                        this.$store.dispatch('pushErros', {
                            title: '[ÚnicoPago] Erro ao Realizar Pagamento',
                            message: JSON.stringify(result),
                            sound: 'mechanical',
                        })
                        this.$store.dispatch('callEventTracker', {
                            event: 'paymentError',
                            extra_params: result,
                        })
                    } else if (
                        typeof result.transaction !== 'undefined' &&
                        result.transaction !== '' &&
                        result.payment_status !== 99
                    ) {
                        this_el.$store.commit('setTransactionData', result)

                        if (action == 'payment-pix') {
                            Swal.fire({
                                title: 'Pagamento via PIX EMITIDO!',
                                html: 'Siga as instruções na próxima tela para realizar o pagamento.',
                                icon: 'success',
                                confirmButtonText: 'INSTRUÇÕES PARA PAGAMENTO PIX',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                                returnFocus: false,
                                willClose: () => {
                                    window.location.href =
                                        this.checkout_url +
                                        '/customer/' +
                                        result.hash
                                },
                            })

                            this.$store.commit('setEventsState', {
                                Purchase: true,
                            })
                        } else if (action == 'payment-billet') {
                            Swal.fire({
                                title: 'Pagamento via BOLETO EMITIDO!',
                                html: 'Siga as instruções na próxima tela para realizar o pagamento.',
                                icon: 'success',
                                confirmButtonText: 'INSTRUÇÕES PARA PAGAMENTO BOLETO',
                                timer: 5000,
                                showCancelButton: false,
                                showConfirmButton: false,
                                timerProgressBar: true,
                                returnFocus: false,
                                willClose: () => {
                                    window.location.href =
                                        this.checkout_url +
                                        '/customer/' +
                                        result.hash
                                    // this.$router.push('/customer/'+result.data_return.create_transaction.transaction);
                                },
                            })

                            this.$store.commit('setEventsState', {
                                Purchase: true,
                            })
                        } else {
                            this.$store.commit('setEventsState', {
                                Purchase: true,
                            })

                            localStorage.setItem('paymentData', JSON.stringify(body.paymentData))

                            localStorage.setItem('gataway', JSON.stringify(this.$store.getters['getGateway']))

                            if (result.payment_status === 3 || result.payment_status === 2) {
                                if (result.acquirer_name === 'appmax') {
                                    this.$store.dispatch('callEventTracker', {
                                        event: 'Purchase',
                                        extra_params: {
                                            payment_method: 'credit_card',
                                            email: this.$store.getters['getCustomer'].email,
                                        },
                                    })
                                }

                                Swal.fire({
                                    title: 'Pagamento Realizado!',
                                    // html: "Produto será entregue via: "+ this.$store.getters['getProduct'].delivery_type,
                                    html: 'Os dados da sua compra foram enviados por e-mail. Aguarde o redirecionamento desta página.',
                                    icon: 'success',
                                    returnFocus: false,
                                    confirmButtonText: 'Ver minha compra',
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    timerProgressBar: true,
                                    willClose: () => {
                                        if (
                                            typeof this.$store.getters[
                                                'getCustomCheckout'
                                            ].thankyou_page !== 'undefined' &&
                                            this.$store.getters[
                                                'getCustomCheckout'
                                            ].thankyou_page !== '' &&
                                            this.$store.getters[
                                                'getCustomCheckout'
                                            ].thankyou_page !== null
                                        ) {
                                            window.location.href =
                                                this.$store.getters[
                                                    'getCustomCheckout'
                                                ].thankyou_page
                                        } else {
                                            window.location.href =
                                                this.checkout_url +
                                                '/customer/' +
                                                result.hash
                                        }
                                    },
                                })
                            } else if (result.payment_status === 7) {
                                Swal.fire({
                                    title: 'Pagamento Recusado',
                                    html: 'Seu pagamento foi recusado, verifique os dados e tente novamente.',
                                    icon: 'error',
                                    showCancelButton: false,
                                    cancelButtonColor: '#6c757d',
                                    cancelButtonText: 'Sair',
                                    returnFocus: false,
                                })

                                posthog.capture('paymentRefused', {
                                    msg: 'Pagamento foi Recusado',
                                })
                                this.$store.dispatch('pushErros', {
                                    title: 'Pagamento Recusado',
                                    message: `Email: ${this_el.$store.getters['getCustomer'].email}  `,
                                    sound: 'falling',
                                })
                            } else if (result.payment_status === 5 && result.payment_method === 1) {
                                Swal.fire({
                                    title: 'Pagamento em análise',
                                    html: 'Seu pagamento está em análise, aguarde a confirmação que será enviada em seu email.',
                                    icon: 'info',
                                    showCancelButton: false,
                                    cancelButtonColor: '#6c757d',
                                    confirmButtonText: 'Ver minha compra',
                                    cancelButtonText: 'Sair',
                                    returnFocus: false,
                                    timer: 5000,
                                    timerProgressBar: true,
                                    willClose: () => {
                                        if (
                                            typeof this.$store.getters[
                                                'getCustomCheckout'
                                            ].thankyou_page !== 'undefined' &&
                                            this.$store.getters[
                                                'getCustomCheckout'
                                            ].thankyou_page !== '' &&
                                            this.$store.getters[
                                                'getCustomCheckout'
                                            ].thankyou_page !== null
                                        ) {
                                            window.location.href =
                                                this.$store.getters[
                                                    'getCustomCheckout'
                                                ].thankyou_page
                                        } else {
                                            window.location.href =
                                                this.checkout_url +
                                                '/customer/' +
                                                result.hash
                                        }
                                    },
                                })
                            } else if (result.payment_status === 5) {
                                const pusher_app_key = this.$config.PUSHER_APP_KEY;
                                if (pusher_app_key) {
                                    window.Pusher = Pusher;

                                    window.Echo = new Echo({
                                        broadcaster: 'pusher',
                                        key: pusher_app_key,
                                        cluster: 'us2',
                                        forceTLS: true,
                                    });

                                    window.Echo.channel(`transactions.${result.hash}`)
                                        .listen('ChangeStatusPix', async (e) => {
                                            if (e.transaction.payment_status == 3) {
                                                this.actCreditcard()

                                                Swal.fire({
                                                    title: 'Pagamento Realizado!',
                                                    html: 'Os dados da sua compra foram enviados por e-mail. Aguarde o redirecionamento desta página.',
                                                    icon: 'success',
                                                    returnFocus: false,
                                                    confirmButtonText: 'Ver minha compra',
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    timer: 5000,
                                                    timerProgressBar: true,
                                                    willClose: () => {
                                                        if (
                                                            typeof this.$store.getters[
                                                                'getCustomCheckout'
                                                            ].thankyou_page !== 'undefined' &&
                                                            this.$store.getters[
                                                                'getCustomCheckout'
                                                            ].thankyou_page !== '' &&
                                                            this.$store.getters[
                                                                'getCustomCheckout'
                                                            ].thankyou_page !== null
                                                        ) {
                                                            window.location.href =
                                                                this.$store.getters[
                                                                    'getCustomCheckout'
                                                                ].thankyou_page
                                                        } else {
                                                            window.location.href =
                                                                this.checkout_url +
                                                                '/customer/' +
                                                                result.hash
                                                        }
                                                    },
                                                })
                                            }

                                            if (e.transaction.payment_status == 7) {
                                                Swal.fire({
                                                    title: 'Pagamento Recusado',
                                                    html: 'Seu pagamento foi recusado, verifique os dados e tente novamente.',
                                                    icon: 'error',
                                                    showCancelButton: false,
                                                    cancelButtonColor: '#6c757d',
                                                    cancelButtonText: 'Sair',
                                                    returnFocus: false,
                                                })

                                                posthog.capture('paymentRefused', {
                                                    msg: 'Pagamento foi Recusado',
                                                })
                                                this.$store.dispatch('pushErros', {
                                                    title: 'Pagamento Recusado',
                                                    message: `Email: ${this_el.$store.getters['getCustomer'].email}  `,
                                                    sound: 'falling',
                                                })
                                            }
                                        });
                                }
                            }
                        }
                    } else if (result.status === 'report_payment_method') {
                        Swal.fire({
                            title: 'Esse cupom não é válido para o método de pagamento selecionado.',
                            html: String(result.message),
                            icon: 'error',
                            showCancelButton: false,
                            cancelButtonColor: '#6c757d',
                            cancelButtonText: 'Sair',
                            returnFocus: false,
                        })
                    } else if (result.status === 'not_found_document') {
                        Swal.fire({
                            title: String(result.message),
                            icon: 'error',
                            showCancelButton: false,
                            cancelButtonColor: '#6c757d',
                            cancelButtonText: 'Sair',
                            returnFocus: false,
                        })
                    } else {
                        Swal.fire({
                            title: '1. Ocorreu um erro ao tentar processar este pagamento',
                            html: '' +
                                (typeof result.refuse_reason !== 'undefined' ?
                                    result.refuse_reason :
                                    result) +
                                '',
                            icon: 'error',
                            showCancelButton: false,
                            cancelButtonColor: '#6c757d',
                            cancelButtonText: 'Sair',
                            returnFocus: false,
                        })

                        posthog.capture('paymentError', result)
                        this.$store.dispatch('pushErros', {
                            title: '1. Ocorreu um erro ao tentar processar este pagamento',
                            message: JSON.stringify(result),
                            sound: 'mechanical',
                        })

                        this.$store.dispatch('callEventTracker', {
                            event: 'paymentError',
                            extra_params: result,
                        })
                    }
                }
            } catch (error) {
                console.error(error)
                console.error(error.response?.data?.message)

                Swal.fire({
                    title: '2. Ocorreu um erro ao tentar processar este pagamento',
                    html: error.response.data.message ??
                        'Ocorreu um erro ao tentar processar o pagamento.',
                    icon: 'error',
                    showCancelButton: false,
                    cancelButtonColor: '#6c757d',
                    cancelButtonText: 'Sair',
                    returnFocus: false,
                })

                posthog.capture('paymentError', error)
                this.$store.dispatch('pushErros', {
                    title: '2. Ocorreu um erro ao tentar processar este pagamento',
                    message: error.response.data.message,
                    sound: 'mechanical',
                })

                this.$store.dispatch('callEventTracker', {
                    event: 'paymentError',
                })
            }
        },
        sendOrder() {
            bpmpi_authenticate();
        }
    },
    watch: {
        submitting: {
            handler(e) {
                if (e !== false) {
                    if (this.payment_method === 1) {
                        this.actCreditcard()
                    } else if (this.payment_method === 2) {
                        this.actBillet()
                    } else if (this.payment_method === 3) {
                        this.actPix()
                    } else {
                        // ERRO

                        posthog.capture('paymentError', {
                            msg: 'Payment Method não identificado' +
                                this.payment_method +
                                '',
                        })
                    }

                    setTimeout(() => {
                        this.$emit('callbackSubmit', false)
                    }, 3000)

                    //
                }
            },
        },
    },
    data() {
        return {
            count_retrys: 0,
            last_transaction_hash_retry: '',
            checkout_url: this.$config.URL_CHECKOUT,
        }
    },
    mounted() {
        this.checkout_url = window.location.origin
    },
} 
</script>
<template>
    <div> </div>
</template>